import script from "./BaseInput.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseInput.vue?vue&type=script&setup=true&lang=js"

import "./BaseInput.vue?vue&type=style&index=0&id=3a83a669&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a83a669"]])

export default __exports__